/**
 * Site header is intentionally empty: navigation is unified into the floating
 * bottom dock (see `BottomNav`). Kept as an export so existing imports remain
 * stable without altering the route shell.
 */
export function SiteHeader() {
  return null;
}
